import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import AppsPriceFilter from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsPriceFilter/AppsPriceFilter";
import AppsPriceFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsPriceFilter/AppsPriceFilterResult";
import FindAppsPriceFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/PriceFilter/PriceFilter";
import type { FindAppsDescriptionDto } from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type { IAppsCommonFiltersDto } from "app/pages/sales-intelligence/store/find-apps/types";

function createPriceFilter(description: FindAppsDescriptionDto): IFilterInstance<IAppsCommonFiltersDto> {
    return {
        key: "price",
        trackingName: "App Price",
        title: { key: "si.find_apps.filters.price.title" },
        tooltipText: { key: "si.find_apps.filters.price.tooltip" },
        filter: new FindAppsPriceFilter({
            options: description.priceFilter,
        }),
        filterView: AppsPriceFilter,
        filterResultView: AppsPriceFilterResult,
    };
}

export default createPriceFilter;
